import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { GridBaseComponent } from '../../../../../components/common/grid-base/grid-base';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { ComparablesValuationsWorkspaceComponent } from '../../workspaces/comparables-valuations-workspace/comparables-valuations-workspace.component';
import { valuationsGridColumns } from './comparables-valuations-grid-config';

/**
 * Comparables valuations grid
 */
@Component({
  selector: 'comparables-valuations-grid',
  templateUrl: './comparables-valuations-grid.component.html',
  styleUrls: ['./comparables-valuations-grid.component.scss']
})
export class ComparablesValuationsGridComponent extends GridBaseComponent implements OnInit {
  /**
   * A reference to the Kendo grid component
   */
  @ViewChild(GridComponent) kendoGrid: GridComponent;

  /**
   * A reference to the workspace
   */
  public get workspaceReference(): WorkspaceBase {
    return this.workspace;
  }

  /**
   * Gets a list of columns
   * @returns
   */
  public getColumns(): PolluxGridConfig[] {
    return valuationsGridColumns;
  }

  /**
   * The workspace
   */
  @Input() workspace: ComparablesValuationsWorkspaceComponent;

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector) {
    super(injector, 'comparablesValuation', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * Handle a row selection / deselection event
   * @param _event The event. Can be null!
   * @param item The item. If an item was deselected, it's null
   */
  protected handleRowSelection(_event: any, item: any): void {
    if (item) {
      this.workspace.onElementSelected(item);
    }
    else {
      this.workspace.onElementDeselected();
    }
  }

  /**
   * Handle a doubleclick event
   * @param _event The event. Can be null!
   * @param item The item
   */
  protected handleDoubleClick(_event: any, item: any): void {
    this.workspace.showForm(item.oid);
  }

  /**
   * Gets the url for loading a paged list
   * @returns The url for loading a paged list
   */
  protected getPagedListEndpoint(): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.comparables.api', `comparables/valuations/list/paged`);
  }

  /**
   * Reset the filters and show all items
   */
  public showAll(): void {
    super.showAll(null);
    this.workspace.onShowAll();
  }


  /**
   * Data loading callback
   * @param data The loaded data
   */
  protected onDataLoaded(data: GridDataResult) {
    this.workspace.setCounterValue('Valuation', data.total);
  }

  /**
   * Callback to apply CSS classes to grid row
   */
  public rowClassCallback = (context: RowClassArgs) => {
    const rowClasses: any = {
      recordStatusInactive: context.dataItem.RecordStatusId === 2
    };

    return rowClasses;
  };
}
